import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import Col from 'react-bootstrap/Col';
import iconbabaji from '../../assets/img/logo.png'
import unnamed from '../../assets/img/image-Photoroom.png'

import Row from 'react-bootstrap/Row';
import './Header.css';
import * as Icon from "react-bootstrap-icons";
// import { useState } from 'react';
import { Link } from 'react-router-dom'
import SidebarData from '../Sidebar/SidebarData'
import SidebarDataOne from '../Sidebar/SidebarDataOne'
import profile from '../../assets/img/logo.png';
import { Button } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { HiOutlineChatBubbleLeftEllipsis } from "react-icons/hi2";

import Cookies from 'js-cookie';
import Whatsapp from '../../assets/img/whatsappicon.png'
import referimg from '../../assets/img/refer.jpg'


export default function Header() {
  const handleReload = () => {
    window.scrollTo(0, 0);
  };

  function refreshPage() {
    setTimeout(() => {
      window.location.reload(false);
    }, 500);
    // console.log('page to reload')
  }
  const user_id = localStorage.getItem("userid");
  const [link, linkDta] = useState([]);
  const [whatsappLink, whatsappLinks] = useState([]);
  const navigate = useNavigate()

  const [linkwhatsapp, linkwhatsappDta] = useState([]);

  function refercode() {
    linkwhatsappDta('https://api.whatsapp.com/send?phone=' + whatsapp);
    // alert(linkwhatsappDta)
    linkDta('https://api.a2logicgroup.com?reffercode=' + user_id);

  }
  const devid = localStorage.getItem("dev_id");
  // alert(user_id)
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [whatsapp, setwhatsapp] = useState([]);
  const handleClick = () => {
    open === true ? setOpen(false) : setOpen(true);
  }

  useEffect(() => {
    const user_id = localStorage.getItem("userid");
    if (user_id == null) {
      window.location.href = '/login';
    };
    if (devid == null) {
      window.location.href = '/login';
    }
    loaduser1();
    loadUser();
    refercode();
  }, [])
  const loadUser = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      const url = `${process.env.REACT_APP_API_URL}/home`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id,
      };

      const response = await axios.post(url, requestData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response?.data) {
        const { current_market_details } = response.data;
        const whatsapp = current_market_details?.whatsap;

        console.warn(whatsapp);
        setwhatsapp(whatsapp);

        if (whatsapp) {
          const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsapp}`;
          whatsappLinks(whatsappLink);
        }
      }
    } catch (error) {
      console.error("Error loading user data:", error);
    }
  };

  const loaduser1 = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");
      const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id,
      };

      const response = await axios.post(url, requestData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response?.data) {
        const { success, login_token } = response.data;

        setUserData(response.data);
        console.warn(response.data);

        if (success === 3 || login_token !== localStorage.getItem("login_token")) {
          localStorage.clear();
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error in loaduser1:", error);
    }
  };






  const logout = (e) => {
    e.preventDefault();
    // localStorage.removeItem(user_id);
    localStorage.clear();
    navigate('/login');
  }
  useEffect(() => {
    const user_id = localStorage.getItem("userid");
    if (user_id == null) {
      window.location.href = '/login';
    };
    if (devid == null) {
      window.location.href = '/login';
    }
    loaduser();
  }, [])

  const loaduser = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      if (!user_id || !dev_id) {
        console.warn("🚨 Missing user_id or dev_id in localStorage.");
        return;
      }
      const url = `${process.env.REACT_APP_API_URL}/user-credit`;
      // JSON request payload
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        dev_id: dev_id
      };
      // Sending request as JSON
      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      // Axios automatically parses JSON response
      const objectRes = response.data;
      if (objectRes) {
        // Uncomment the line below to set users if needed
        // setUsers(objectRes);
        console.warn("✅ User credit data loaded successfully:", objectRes);
      } else {
        console.warn("⚠️ No user credit data received from API.");
      }

    } catch (error) {
      console.error("🚨 Error fetching user credit data:", error);
    }
  };

  return (
    <>
      <div className='header-top'>
        <Container fluid>
          <Row className='d-flex align-items-center justify-content-between'>
            <Col xs={4} md={3} s={4}>
              <div className="menuicon d-flex justify-content-between" >
                <i class="bi bi-list" onClick={handleClick}></i>
                <i class="bi bi-arrow-clockwise" onClick={refreshPage}></i>

              </div>

            </Col>
            <Col xs={4} md={2} s={4}>
              <Link to="/">
                <img src={iconbabaji} width="40" className='mx-auto d-flex justify-content-end' />
              </Link>
            </Col>
            {/* {userData && userData.is_playstore == 0 ? */}
            <Col xs={4} md={6} s={4}>
              <div className="d-flex justify-content-between align-items-center">

                <Link to="/Notification" onClick={handleReload} className='buttonpage'>

                  <i class="bi bi-bell-fill text-white"></i>
                </Link>

                {/* <Link
                    to="/Chat"
                    onClick={handleReload}
                    className="buttonpage"
               
                  >
                    <Col
                      xs={4}
                      md={2}
                      s={4}
                      style={{
                        fontSize: "50px",
                        borderRadius: "15px",
                     
                      }}
                    >
                      <img
                        src={unnamed}
                        width="60"
                        height="60" // Added height
                        className="mx-auto d-flex justify-content-end"
                        style={{ borderRadius: "50%",   fontSize: "100px" }}
                      />
                    </Col>
                  </Link> */}



                <div className='ms-auto'>
                  <a href={whatsappLink} id="whatsappLink" className="whatsapp_log d-block">
                    <img src={Whatsapp} className=" whatsapp_icon" />
                  </a>
                </div>
                <div>
                </div>
              </div>
            </Col>
            {/* : */}
            {/* <></> */}
            {/* } */}
          </Row>
        </Container>
        {/* {Sidebardata.map(value =>
         
         )} */}

      </div>
      <div className={open ? "sidebar is-toggle" : "sidebar"} >
        <div className="profileimage">
          <Button className="closebtn" onClick={handleClick}>
            &times;
          </Button>
          {userData && (
            <div className="d-flex align-items-center justify-content-between">

              <div className="profilephoto">
                <img src={profile} />
              </div>

              <div className="profiledetails">
                <h3>{userData.name}</h3>
                <h4><strong>ID : </strong>{user_id}</h4>
              </div>
            </div>
          )}
        </div>
        {/* {userData && userData.is_playstore == 0 ? */}
        <ul className="bg-white menulist">
          {SidebarData.map(val =>
            <li>
              {val.title == "Logout" ? (
                <Link to={val.path} onClick={logout} className={val.ownclass}>
                  {val.icon}
                  {val.title}
                </Link>
              ) : (
                <Link to={val.path} onClick={handleClick} className={val.ownclass}>
                  {val.icon}
                  {val.title}
                </Link>
              )}
            </li>
          )}
        </ul>
        :
        <ul className="bg-white menulist">
          {SidebarDataOne.map(val =>
            <li>
              {val.title == "Logout" ? (
                <Link to={val.path} onClick={logout} className={val.ownclass}>
                  {val.icon}
                  {val.title}
                </Link>
              ) : (
                <Link to={val.path} onClick={handleClick} className={val.ownclass}>
                  {val.icon}
                  {val.title}
                </Link>
              )}
            </li>
          )}
        </ul>
        {/* } */}
      </div>
      <div className={`sidebar-overlay ${open == true ? 'active' : ''}`} onClick={handleClick}></div>
    </>
  )
}
